<template>
  <div class="flex_end">
    <router-link
      :to="{path:'/service/split'}"
      target="_blank"
      class="split-link">
      <u>スプリットとは</u>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SplitInformationLink',
}
</script>

<style scoped>
.flex_end {
  display:flex;
  justify-content: flex-end
}
</style>
